/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowLeft: {
  name: 'arrow_left';
  data: string;
} = {
  name: 'arrow_left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M20.25 12.75a.75.75 0 0 0 0-1.5H5.56l5.47-5.47a.75.75 0 1 0-1.06-1.06l-6.75 6.75a.748.748 0 0 0 0 1.06l6.75 6.75a.75.75 0 1 0 1.06-1.06l-5.47-5.47h14.69Z" fill="currentColor"/></svg>`
};
